'use strict';

require('react');
require('classnames');
require('../Box/Box.js');
require('../../style-inject.es-dcee06b6.js');
var components_Text_Text = require('./Text.js');



module.exports = components_Text_Text;
